const MALE_CDN_IMAGE = 'https://common-discovery-service-pgp.familysearchcdn.org/connect/avatars/gender-male.png'
const FEMALE_CDN_IMAGE = 'https://common-discovery-service-pgp.familysearchcdn.org/connect/avatars/gender-female.png'
const UNKNOWN_CDN_IMAGE = 'https://common-discovery-service-pgp.familysearchcdn.org/connect/avatars/gender-unknown.png'

const dataURItoBlob = (dataURI) => {
  const binary = atob(dataURI?.split(',')[1])
  const array = []
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i))
  }
  return new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
}

const getUrlFromBlobOrFile = (file) => {
  return new Promise((resolve, reject) => {
    if (!(file instanceof Blob) && !(file instanceof File)) {
      reject(new Error('Invalid input. Expected a File or Blob.'))
      return
    }

    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}

/**
 * Simple function that converts a plain SVG string or SVG DOM Node into an image with custom dimensions.
 *
 * @param {Object} settings The configuration object to override the default settings.
 * @see https://ourcodeworld.com/articles/read/1456/how-to-convert-a-plain-svg-string-or-svg-node-to-an-image-png-or-jpeg-in-the-browser-with-javascript
 * @returns {Promise}
 */
const svgToImage = (settings) => {
  const usedsettings = {
    svg: null,
    // Usually all SVG have transparency, so PNG is the way to go by default
    mimetype: 'image/png',
    quality: 0.92,
    width: 'auto',
    height: 'auto',
    outputFormat: 'base64',
  }

  // Override default settings
  Object.keys(settings).forEach((key) => {
    usedsettings[key] = settings[key]
  })

  return new Promise((resolve) => {
    let svgNode

    // Create SVG Node if a plain string has been provided
    if (typeof usedsettings.svg === 'string') {
      // Create a non-visible node to render the SVG string
      const SVGContainer = document.createElement('div')
      SVGContainer.style.display = 'none'
      SVGContainer.innerHTML = usedsettings.svg
      svgNode = SVGContainer.firstElementChild
    } else {
      svgNode = usedsettings.svg
    }

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    const svgXml = new XMLSerializer().serializeToString(svgNode)
    const svgBase64 = `data:image/svg+xml;base64,${btoa(svgXml)}`

    const image = new Image()
    image.crossOrigin = 'anonymous'

    image.onload = (e) => {
      const img = e.target
      let finalWidth
      let finalHeight

      // Calculate width if set to auto and the height is specified (to preserve aspect ratio)
      if (usedsettings.width === 'auto' && usedsettings.height !== 'auto') {
        finalWidth = (img.width / img.height) * usedsettings.height
        // Use image original width
      } else if (usedsettings.width === 'auto') {
        finalWidth = img.naturalWidth
        // Use custom width
      } else {
        finalWidth = usedsettings.width
      }

      // Calculate height if set to auto and the width is specified (to preserve aspect ratio)
      if (usedsettings.height === 'auto' && usedsettings.width !== 'auto') {
        finalHeight = (img.height / img.width) * usedsettings.width
        // Use image original height
      } else if (usedsettings.height === 'auto') {
        finalHeight = img.naturalHeight
        // Use custom height
      } else {
        finalHeight = usedsettings.height
      }

      // Define the canvas intrinsic size
      canvas.width = finalWidth
      canvas.height = finalHeight

      // Render image in the canvas
      context.drawImage(img, 0, 0, finalWidth, finalHeight)

      if (usedsettings.outputFormat === 'blob') {
        // Fullfil and Return the Blob image
        canvas.toBlob(
          (blob) => {
            resolve(blob)
          },
          usedsettings.mimetype,
          usedsettings.quality
        )
      } else {
        // Fullfil and Return the Base64 image
        resolve(canvas.toDataURL(usedsettings.mimetype, usedsettings.quality))
      }
    }

    // Load the SVG in Base64 to the image
    image.src = svgBase64
  })
}

const getGenderAppearanceByUrl = (gender) => {
  if (gender?.toUpperCase() === 'FEMALE') {
    return FEMALE_CDN_IMAGE
  }
  if (gender?.toUpperCase() === 'MALE') {
    return MALE_CDN_IMAGE
  }
  return UNKNOWN_CDN_IMAGE
}

export { dataURItoBlob, getUrlFromBlobOrFile, svgToImage, getGenderAppearanceByUrl }
